import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DASHBOARD_REPOSITORY } from '../domain/repositories/dashboard.repository';
import { DashboardRemoteDatasource } from './datasources/remote/dashboard.remote-datasource';
import { DashboardMapper } from './mappers/dashboard.mapper';
import { DashboardRepositoryImpl } from './repositories/dashboard.repository.impl';

export function provideDashboardData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    DashboardRemoteDatasource,
    DashboardMapper,
    { provide: DASHBOARD_REPOSITORY, useClass: DashboardRepositoryImpl },
  ]);
}
